import { render, staticRenderFns } from "./ArticleVariants.vue?vue&type=template&id=022e1a70"
import script from "./ArticleVariants.vue?vue&type=script&lang=js"
export * from "./ArticleVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports